import { buildOidcLoginPath, readOidcLoginPageQueryState, sanitizeOidcRedirectPath } from "@airange/shared/oidc-routes";

export type UmiSsoGuardOptions = {
  initialStateReady: boolean,
  pathname: string,
  search?: string,
  hash?: string,
  loginPath: string,
  hasAccess: boolean,
  defaultAuthorizedPath: string,
  includeRedirectParam?: boolean,
};

function buildCurrentPath(search = "", hash = "", pathname = "/") {
  return `${pathname || "/"}${search || ""}${hash || ""}`;
}

export function buildUmiLoginRedirectPath(
  loginPath: string,
  pathname: string,
  search = "",
  hash = "",
  defaultAuthorizedPath?: string,
) {
  if (loginPath === "/login") {
    return buildOidcLoginPath({
      defaultRedirectPath: defaultAuthorizedPath || "/",
      redirectPath: buildCurrentPath(search, hash, pathname),
    });
  }
  const redirectTarget = buildCurrentPath(search, hash, pathname);
  return `${loginPath}?redirect=${encodeURIComponent(redirectTarget)}`;
}

export function resolveUmiSsoGuardRedirect(options: UmiSsoGuardOptions) {
  const {
    initialStateReady,
    pathname,
    search = "",
    hash = "",
    loginPath,
    hasAccess,
    defaultAuthorizedPath,
    includeRedirectParam = true,
  } = options;

  if (!initialStateReady) {
    return null;
  }

  if (!hasAccess) {
    if (pathname === loginPath) {
      return null;
    }
    return includeRedirectParam
      ? buildUmiLoginRedirectPath(loginPath, pathname, search, hash, defaultAuthorizedPath)
      : loginPath;
  }

  if (pathname !== loginPath) {
    return null;
  }

  if (loginPath === "/login") {
    return readOidcLoginPageQueryState(search, defaultAuthorizedPath).redirectPath;
  }

  const queryRedirect = new URLSearchParams(search).get("redirect");
  return sanitizeOidcRedirectPath(queryRedirect, defaultAuthorizedPath);
}
